import { FC } from 'react'

import { EmbroideryGroupSummary } from '../../../containers/EmbroideryContainer/utils/summarizeEmbroideryGroup'
import { SneakPeeksWrapper } from '../EmbroiderySneakPeek/styles'

import { EmbroideryLineSneakPeek } from './EmbroideryLineSneakPeek'
import { EmbroideryTypeSneakPeeks } from './EmbroideryTypeSneakPeeks'

interface Props {
  summary: EmbroideryGroupSummary
  hasLogoSetup: boolean
  // Order history hides prices outside the US
  showPrices?: boolean
}

/** Sneak peeks for one garment's embroidery: per-type sections for v2, per-line content otherwise. */
export const EmbroideryGroupContent: FC<Props> = ({ summary, hasLogoSetup, showPrices = true }) => (
  <SneakPeeksWrapper style={{ marginTop: '12px' }}>
    {summary.layout === 'combined'
      ? summary.lines.map(l => (
          <EmbroideryLineSneakPeek
            key={l.key}
            hasLogoSetup={hasLogoSetup}
            properties={l.properties}
          />
        ))
      : summary.sections.map(s => (
          <EmbroideryTypeSneakPeeks
            key={s.type}
            section={s}
            hasLogoSetup={hasLogoSetup}
            showPrices={showPrices}
          />
        ))}
  </SneakPeeksWrapper>
)
